import { I18nContent } from ".";

const de: I18nContent = {
  translations: {
    archiveNotification: "Benachrichtigung archivieren",
    archiveRead: "Gelesenes Archivieren",
    markAllAsRead: "Alle als gelesen markieren",
    notifications: "Benachrichtigungen",
    emptyFeedTitle: "Noch keine Benachrichtigungen",
    emptyFeedBody:
      "Wir werden dich benachrichtigen, sobald wir etwas Neues für dich haben.",
    all: "Alle",
    unread: "Ungelesen",
    read: "Gelesen",
    unseen: "Ungesehen",
    slackConnectChannel: "Kanal verbinden",
    slackChannelId: "Slack Kanal ID",
    slackConnecting: "Verbinden mit Slack...",
    slackDisconnecting: "Trennen der Verbindung...",
    slackConnect: "Mit Slack verbinden",
    slackConnected: "Verbunden",
    slackConnectContainerDescription:
      "Verbinden, um Benachrichtigungen in Ihrem Slack-Arbeitsbereich zu erhalten.",
    slackSearchbarDisconnected: "Slack ist nicht verbunden.",
    slackSearchbarNoChannelsConnected: "Suchkanäle",
    slackSearchbarNoChannelsFound: "Keine schlaffen Kanäle.",
    slackSearchbarChannelsError: "Fehler beim Abrufen von Kanälen.",
    slackSearchChannels: "Suchkanäle",
    slackConnectionErrorExists:
      "Versuchen Sie, sich erneut mit Slack zu verbinden, um Kanäle in Ihrem Arbeitsbereich zu finden und auszuwählen.",
    slackConnectionErrorOccurred:
      "Es ist ein Fehler beim Verbinden mit Slack aufgetreten. Versuchen Sie, sich erneut zu verbinden, um Kanäle in Ihrem Arbeitsbereich zu finden und auszuwählen.",
    slackChannelAlreadyConnected: "Fehler: bereits verbunden",
    slackError: "Fehler",
    slackDisconnect: "Trennen Sie die Verbindung.",
    slackChannelSetError: "Fehlereinstellung Kanal.",
    slackAccessTokenNotSet: "Zugriffstoken nicht gesetzt.",
    slackReconnect: "Neu verbinden",
  },
  locale: "de",
};

export default de;
